import styled, { keyframes } from 'styled-components'

const size = keyframes`
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
`;
//animation: ${size} 1s linear forwards;
const Divider = styled.div`
  width: ${props => props.width ? `${props.width }` : `90%`};
  margin: ${props => props.margin ? `${props.margin }` : `.7rem auto`};
  height: 1px;
  background-color:${props => props.backgroundColor ? `${props.backgroundColor }` : `#FAFAFA`};
`

export default Divider